import { Collection } from '@msw/data';
import z from 'zod';

import type { PostListItem } from '@/entities/post/types';
import { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter/constants';
import dayjs from 'dayjs';

const BoardSchema = z.object({
  id: z.string(),
  title: z.string(),
  updated_at: z.string(),
});

const BoardPostSchema = z.object({
  board_id: z.string(),
  post: z.unknown(),
});

export const boardCollection = new Collection({
  schema: BoardSchema,
});

export const boardPostCollection = new Collection({
  schema: BoardPostSchema,
});

function createSeedBoardPost(
  boardId: string,
  index: number,
): { board_id: string; post: PostListItem } {
  const now = dayjs();
  const nowString = now.toISOString();
  const postedAt = now.subtract(index, 'hours').toISOString();

  return {
    board_id: boardId,
    post: {
      _id: `mock-post-${boardId}-${index}`,
      date: postedAt,
      author: {
        author_id: `mock-author-${index}`,
        follower_count: 10000 + index * 100,
        following_count: 200,
        nickname: `Creator ${index}`,
        profile_image_url: `https://picsum.photos/seed/author-${index}/80/80`,
        profile_url: `https://example.com/creator/${index}`,
        region: 'US',
        total_like_count: 20000,
        username: `creator_${index}`,
      },
      source: {
        id: `mock-source-${index}`,
        platform: index % 2 === 0 ? SOURCE_PLATFORM_TYPE.INSTAGRAM : SOURCE_PLATFORM_TYPE.TIKTOK,
        url: `https://example.com/post/${index}`,
      },
      extraction: {
        content: `Mock board post content ${index}`,
        engagement: {
          view: 1000 + index * 100,
          like: 200 + index * 10,
          comment: 20 + index,
          shared: 10 + index,
          rate: 0.03 + index / 1000,
        },
        hashtags: [],
        location: '',
        video: {
          url: `https://cdn.example.com/video-${index}.mp4`,
          poster_url: `https://picsum.photos/seed/board-${index}/480/640`,
        },
      },
      scraped_at: nowString,
      updated_at: nowString,
      board_count: 1,
    },
  };
}

export async function initMockBoardDB() {
  boardCollection.clear();
  boardPostCollection.clear();

  const seededBoards = [
    {
      id: 'mock-board-ugc',
      title: 'UGC Ads Candidates',
      updated_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: 'mock-board-benchmark',
      title: 'Competitor Hooks',
      updated_at: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    },
  ];

  for (const board of seededBoards) {
    await boardCollection.create(board);
  }

  const seededPosts = [
    createSeedBoardPost('mock-board-ugc', 1),
    createSeedBoardPost('mock-board-ugc', 2),
    createSeedBoardPost('mock-board-ugc', 3),
  ];

  for (const record of seededPosts) {
    await boardPostCollection.create(record);
  }
}
